var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    stroke: "#6e6e6e",
    strokeWidth: "`",
    fill: "grey"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10.7,
    y: 18.5,
    fontSize: "20px",
    fill: "white"
  }, "-")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownToken);
export default __webpack_public_path__ + "static/media/unknown-token.c16b13dcfcfafbd6a33661a2bf698e4d.svg";
export { ForwardRef as ReactComponent };